import toastMessage from "../../toastMessage";
import { getStorage } from "../../storage";
import api from "../../api";
import language from "../../../language";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;
const QUALYS_RESULTS_CLIENT_TOKEN =
  process.env.REACT_APP_QUALYS_RESULTS_CLIENT_TOKEN ||
  "b0bef30d5b7adbfce7ecf2111999617b3809a6de1534723e49a248c2d3824824";

const getHeaders = async () => {
  const user = await getStorage();

  return {
    Authorization: user?.token ? `Bearer ${user.token}` : undefined,
    "x-client-token": QUALYS_RESULTS_CLIENT_TOKEN,
  };
};

export const fetchQualysResult = async (
  lng = "english",
  {
    page,
    limit,
    sampleId,
    messageId,
    instrumentRunId,
    operator,
    labStatus,
    startDate,
    endDate,
  }
) => {
  try {
    const headers = await getHeaders();

    const options = {
      method: "GET",
      url: `${API_URL}/qualys/results`,
      params: {
        page,
        limit,
        sampleId,
        messageId,
        instrumentRunId,
        operator,
        labStatus,
        startDate,
        endDate,
      },
      headers,
    };

    const queryRes = await api(options);
    const { data, count, totalRecords } = queryRes.data;

    return !page && !limit ? queryRes.data?.data : { data, count, totalRecords };
  } catch (error) {
    toastMessage("error", error);
  }
};

export const deleteQualysResult = async (lng = "english", id) => {
  try {
    const headers = await getHeaders();

    const options = {
      method: "DELETE",
      url: `${API_URL}/qualys/results`,
      data: {
        id,
      },
      headers,
    };

    await api(options);

    toastMessage("success", language[lng].success_delete_test);
  } catch (error) {
    toastMessage("error", error);
  }
};
